import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { OpeExtDtoResponse } from 'src/app/models/OpeExtDtoResponse';
import { EntitebackService } from 'src/app/services/entite/entiteback.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';

@Component({
  selector: 'app-liste-programmes',
  templateUrl: './liste-programmes.component.html',
  styleUrls: ['./liste-programmes.component.scss'],
  imports:[TableModule,ButtonModule],
  providers: [MessageService]
})
export class ListeProgrammesComponent implements OnInit {

  constructor(public share: shareOpeSevices, public entiteService: EntitebackService, public messageService: MessageService) { }
  programmes!: OpeExtDtoResponse[];
  entiteId: any;
  ngOnInit() {
    this.share.noeudficheEntite$.subscribe(data => {
      this.entiteId = data?.data?.id;
      this.entiteService.getOpeExtAffecteEntite(data?.data?.id).subscribe(data => {
        this.programmes = data;
      }
      )
    })
  }

  delete(program: OpeExtDtoResponse) {

    this.share.showprogressbar = true;

    this.entiteService.deleteOpeFromEntite(this.entiteId, program.numOpe).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', detail: 'Le programme ' + program.libelle + ' a été supprimé avec succés' });
        this.entiteService.getOpeExtAffecteEntite(this.entiteId).subscribe(data => {
          this.programmes = data;
        });
        this.share.showprogressbar = false;
      },
      error: err => {
        this.messageService.add({ severity: 'error', detail: 'Erreur de suppression du programme ' + program.libelle });
        this.share.showprogressbar = false;
      }
    })
  }

}
